import styled from 'styled-components';

export const ModalFooter = styled.div`
    background: var(--app-background);
    position: relative;
    z-index: var(--z-index-modal-footer);
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: var(--modal-padding-footer-top) var(--modal-padding) var(--modal-padding);
    &::before {
        content: '';
        height: 20px;
        width: 100%;

        position: absolute;
        top: 0;
        left: 0;
        transform: translateY(-20px);
        display: block;
        background-image: linear-gradient(to top, var(--app-background), var(--main-body-background-color-transp));
    }
`;
